import React from 'react';
import classNames from 'classnames';

import styles from './RadioWidget.module.scss';

export default function RadioWidget({
  done,
  error,
  id,
  label,
  ...props
}: RadioWidgetType): JSX.Element {
  return (
    <label
      className={classNames(styles.container, {
        [styles.done]: done,
        [styles.error]: error,
      })}
      htmlFor={id}
    >
      <span className={styles.inputContainer}>
        <input id={id} type={'radio'} {...props} />
        <span className={styles.customRadio}>
          <span className={styles.checkmark}></span>
        </span>
      </span>
      <span className={styles.label}>{label}</span>
    </label>
  );
}

export type RadioWidgetType = React.InputHTMLAttributes<HTMLInputElement> & {
  done?: boolean;
  error?: boolean;
  id: string;
  label?: string;
  value: string;
};
